module.exports = __webpack_public_path__ + "h5/img/logo2.a527c250.png";